import type { SVGProps } from 'react';
import type { SVGRType } from '../types';

const SvgClose = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRType) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 24 24'
    width='24'
    height='24'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M4.74297 17.2508C4.28023 16.7961 4.29619 15.9903 4.72701 15.5594L9.29054 10.9959L4.72701 6.44833C4.29619 6.00953 4.28023 5.21171 4.74297 4.74898C5.2057 4.27826 6.0115 4.29422 6.44232 4.73302L10.9979 9.28858L15.5534 4.73302C16.0002 4.28624 16.7821 4.28624 17.2448 4.74898C17.7155 5.21171 17.7155 5.99358 17.2608 6.44833L12.7132 10.9959L17.2608 15.5515C17.7155 16.0062 17.7076 16.7801 17.2448 17.2508C16.7901 17.7136 16.0002 17.7136 15.5534 17.2668L10.9979 12.7112L6.44232 17.2668C6.0115 17.7056 5.21368 17.7136 4.74297 17.2508Z' />
  </svg>
);

export default SvgClose;
